export default __webpack_public_path__ + "static/australia-377c6c68e0593b1f73d64141384144f5.svg";